export default "__VITE_ASSET__BptZC4d4__"